import PlayerRemoteBase from "./PlayerRemoteBase";

class Remote {

    constructor(args = {}) {
        this.args = args;
    }

    get Instance() {

        let _setShowSlider, _args = this.args

        const Remote = class PS extends PlayerRemoteBase {

            constructor() {
                super();
            }

            sync(o) {
                super.sync(o)
                _setShowSlider = _setShowSlider || o.setShowSlider;
            }

            showSlider(bool) {
                _setShowSlider(!!bool);
            }

        }

        return new Remote;
    }
}

export default Remote;